var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgfg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 697 559",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M337.221 14.293c17.835-17.835 46.83-17.756 64.762.176L683.384 295.87c17.93 17.93 18.011 46.928.177 64.762l-46.133 46.133c-17.835 17.835-46.832 17.753-64.762-.177L291.265 125.187c-17.932-17.932-18.011-46.927-.177-64.762l46.133-46.132ZM198.823 152.69c17.835-17.835 46.83-17.756 64.762.176l281.401 281.401c17.93 17.93 18.012 46.927.177 64.762l-46.133 46.133c-17.835 17.835-46.832 17.754-64.762-.177L152.867 263.585c-17.932-17.932-18.011-46.927-.176-64.762l46.132-46.132Zm-73.635 138.573c-17.932-17.932-46.927-18.011-64.764-.175l-46.13 46.131c-17.836 17.836-17.756 46.83.176 64.762l129.877 129.877c17.933 17.933 46.927 18.013 64.762.177l46.131-46.131c17.836-17.836 17.757-46.831-.175-64.764L125.188 291.264Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 170.967,
    x2: 788.435,
    y1: 173.403,
    y2: 736.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F323C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#152A33"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgfg);
export default __webpack_public_path__ + "static/media/bgfg.321716598ca0a687d87fb83a0b737452.svg";
export { ForwardRef as ReactComponent };